"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Header_1 = __importDefault(require("./components/Header/Header"));
const Events_1 = require("./components/Events/Events");
const Contact_1 = require("./components/Contact/Contact");
const Hosts_1 = require("./components/Hosts/Hosts");
const About_1 = require("./components/About/About");
const Discord_1 = require("./components/Discord/Discord");
/**
 * DO we want to have separate pages for the about section and events?
 * or just everything on the main page
 */
const App = () => {
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(Header_1.default, null),
        react_1.default.createElement("h1", null, "Welcome to the Twin Cities Cardboard Crew"),
        react_1.default.createElement(About_1.About, null),
        react_1.default.createElement(Discord_1.Discord, null),
        react_1.default.createElement(Events_1.Events, null),
        react_1.default.createElement(Hosts_1.Hosts, null),
        react_1.default.createElement(Contact_1.Contact, null)));
};
exports.default = App;
